import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  edittravelCategory,
  gettravelCategoryList,
} from "../store/slices/category";
import { nameregex } from "../helper/regex";

const EditTravelCategory = () => {
  const { id } = useParams();
  const [categoryName, setcategoryName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Fetch Place Details
  useEffect(() => {
    const fetchcategoryDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(gettravelCategoryList(item)).unwrap();
        const category = data?.categoryData[0];

        if (category) {
          setcategoryName(category.categoryName || "");
        }
      } catch (error) {
        console.error("Failed to fetch place details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchcategoryDetails();
  }, [dispatch, id]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "categoryName":
        setcategoryName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid category name"
            : "";
        break;
      default:
        break;
    }

    setErrors(validationErrors);
  };

  const EditPlaces = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};
    if (!categoryName.trim()) {
      validationErrors.categoryName = "Please enter category name";
    } else if (!nameregex.test(categoryName)) {
      validationErrors.categoryName = "Please enter a valid category name";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const item = {
      id,
      categoryName,
    };

    try {
      await dispatch(edittravelCategory(item)).unwrap();
      navigate("/admin/travel-category");
      alert("Travel category details edited successfully!");
    } catch (error) {
      alert(error);
    }
  };

  // Handle Cancel
  const cancel = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Tour Category</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/travel-category"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Tour Category
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Tour Category</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={EditPlaces}>
            <div className="row mb-40">
              {/* Name Field */}
              <div className="col-md-5">
                <label className="form-label">
                  Category Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="categoryName"
                  value={categoryName}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.categoryName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Category Name"
                />
                {errors.categoryName && (
                  <div className="text-danger mt-2">{errors.categoryName}</div>
                )}
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditTravelCategory;
